<template>
  <div>
    <button :style="{opacity: previousPageButtonDisabled? 0.5 : 1}" :disabled="previousPageButtonDisabled" @click="previous" class="button">&lt;</button>
    <button :style="{opacity: nextPageButtonDisabled? 0.5 : 1}" :disabled="nextPageButtonDisabled" @click="next" class="button">&gt;</button>
  </div>
</template>

<script>
export default {
  props: {
    count: { type: Number, default: 0 },
    page: { type: Number, default: 1 },
    perPage: { type: Number, default: 5 },
    isLastPage: Boolean
  },
  computed: {
    previousPageButtonDisabled(){
      return this.page === 1
    },
    nextPageButtonDisabled(){
      return this.isLastPage
    }
  },
  methods: {
    next() {
      if (!this.isLastPage) {
        this.$emit("next-page", this.page);
      }
    },
    previous() {
      if (this.page > 1) {
        this.$emit("previous-page", this.page);
      }
    },
  },
  emits: ["previous-page", "next-page"]
};
</script>
<style scoped>
.button {
  width: 40px;
  height: 30px;
  border: 1px solid #01e069;
  background: #01e069;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  margin: 2px 1px;
  cursor: pointer !important;
  z-index: 1;
  outline: none;
}
</style>